import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Organization } from '../_models/Organization';
import { BaseService } from '../_shared/base.service';
import { getUrl } from '../_shared/utils';
import { JWTTokenService } from './jwtToken.service';

@Injectable()
export class OrganizationService extends BaseService {
    userToken: any;
    decodedToken: any;

    constructor(private http: HttpClient, jwtTokenService: JWTTokenService) {
        super(http, jwtTokenService);
    }

    public getAllOrganizations(): Observable<Organization[]> {
        return this.http.get<Organization[]>(getUrl('auth/organization'), this.requestOptionsAuthenticated());
    }

    public getOrganization(id): Observable<Organization> {
        return this.http.get<Organization>(getUrl('organization/' + id), this.buildOptions()).pipe(map(c => this.map(c)));
    }

    public deleteOrganization(id): Observable<Organization> {
        return this.http.delete<Organization>(getUrl('organization/' + id), this.buildOptions());
    }

    createOrganization(model: Organization): Observable<Organization> {
        this.RemoveFromCache('organizationList');
        const endpoint = getUrl('organization');
        if (model.organizationId !== null) {
            return this.http.put<Organization>(endpoint, model, this.buildOptions());
        } else {
            return this.http.post<Organization>(endpoint, model, this.buildOptions());
        }
    }

    private requestOptionsAuthenticated() {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken('portal')),
        };
        return requestOptions;
    }

    private map(org: any): Organization {

        return <Organization>{
            name: org.name,
            organizationId: org.organizationId,
            active: org.active
        };
    }
}
